import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerIntl, MatDatepickerModule } from '@angular/material/datepicker';
import { LocalizedMatDatepickerIntl } from './services/datepicker-intl/localized-mat-datepicker-intl.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIconsModule } from '@ng-icons/core';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDividerModule} from '@angular/material/divider';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';
import {MatIconModule} from '@angular/material/icon';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    MatInputModule,
    MatFormFieldModule,
    NgIconsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSidenavModule,
    MatTabsModule,
    MatSelectModule,
    MatToolbarModule,
    MatDatepickerModule,
    DragDropModule,
    MatCheckboxModule,
    PortalModule,
    MatDividerModule,
    MatRadioModule,
    MatSliderModule,
    MatIconModule,
    OverlayModule,
    MatDialogModule,
    MatBottomSheetModule,
    ClipboardModule,
    CdkStepperModule,
    MatExpansionModule,
    MatMenuModule,
    MatSnackBarModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  providers: [
    // a11y: override Material's default English MatDatepickerIntl with a
    // locale-aware service so the calendar toggle / prev / next / "choose
    // month and year" buttons announce Hebrew / English / Arabic names.
    { provide: MatDatepickerIntl, useClass: LocalizedMatDatepickerIntl },
  ],
})
export class MaterialModule {}
